import * as React from 'react';

import Layout from 'components/Layout';
import SEO from 'components/SEO';

import ToolchainHero from 'pageComponents/Integrations/ToolchainHero';
import PartnerGrid from 'pageComponents/Integrations/PartnerGrid';

const IntegrationsPage = () => {
  return (
    <Layout>
      <ToolchainHero />
      <PartnerGrid />
    </Layout>
  );
};

export default IntegrationsPage;

export function Head({ location }) {
  return (
    <SEO
      title="Integrations"
      description="Sleuth integrates with your source control, CI/CD pipeline tools, and observability tools:  GitLab, Bitbucket, CircleCI, Sentry, Datadog, New Relic, and more."
      location={location}
    />
  );
}
